module.exports = __webpack_public_path__ + "static/media/alignBottom.1744a9aa.svg";